var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 3.75C4.42125 3.75 3.75 4.42125 3.75 5.25V18.75C3.75 19.5787 4.42125 20.25 5.25 20.25H18.75C19.5787 20.25 20.25 19.5787 20.25 18.75V6.75L17.25 3.75H15.75V8.25C15.75 8.664 15.414 9 15 9H8.25C7.836 9 7.5 8.664 7.5 8.25V3.75H5.25ZM12.75 3.75V7.5H14.25V3.75H12.75ZM8.25 12.75H15.75C16.5787 12.75 17.25 13.4213 17.25 14.25V18.75H6.75V14.25C6.75 13.4213 7.42125 12.75 8.25 12.75Z",
    fill: "#365EDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.db8955d0.svg";
export { ForwardRef as ReactComponent };